module.exports = __webpack_public_path__ + "static/media/order-request-mobile.6722ef1d.png";